import React from 'react';

const RatingStar = ({ rating }: { rating: number }) => {
  const fullStars = Math.floor(rating); // 채워진 별의 개수
  const partialStarPercentage = (rating % 1) * 100; // 남은 별의 백분율
  const emptyStars = 5 - Math.ceil(rating); // 빈 별의 개수

  return (
    <div className="flex space-x-[1px]">
      {/* 채워진 별들 */}
      {[...Array(fullStars)].map((_, index) => (
        <span key={index} className="text-yellow-500">★</span>
      ))}

      {/* 부분적으로 채워진 별 */}
      {partialStarPercentage > 0 && (
        <span className="relative">
          <span className="text-gray-300">★</span>
          <span
            className="text-yellow-500 absolute top-0 left-0 overflow-hidden"
            style={{ width: `${partialStarPercentage}%` }}
          >
            ★
          </span>
        </span>
      )}

      {/* 빈 별들 */}
      { emptyStars > 0 && [...Array(emptyStars)].map((_, index) => (
        <span key={index} className="text-gray-300">★</span>
      ))}
    </div>
  );
};

export default RatingStar;